import { useMemo } from 'react'
import styled from 'styled-components'
import { COLORS } from '../utils'

const SVG = styled.svg`
  max-width: 90%;
  width: 100px;
`

const PulsingLogo = ({ type, shadow = true, pulse = true }) => {
  const colors = useMemo(() => {
    return COLORS[type] || COLORS.default
  }, [type])

  return (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 216 232" fill="none">
      <g filter={`url(#filter-${type})`}>
        <path d="M162.309 55.289l-26.458 12.71 2.321-17.022c.696-6.355-5.803-10.894-11.605-8.17L57.869 75.487c-2.553 1.135-4.178 3.404-4.41 6.128l-11.373 86.698c-.928 6.354 5.803 10.894 11.605 8.17l26.458-12.483-2.32 17.022c-.697 6.355 5.802 10.894 11.604 8.171l68.698-32.682c2.553-1.135 4.178-3.405 4.41-6.128l11.373-86.698c.928-6.581-5.803-11.12-11.605-8.397zm-12.301 80.343c-.696 5.674-4.177 10.44-9.515 12.936L108 164.001c-5.57 2.724-11.837-1.815-11.14-7.716l39.455-18.838 2.089-15.66-7.891-5.447c-.697-.453-.697-1.588.232-2.042l23.441-11.121-4.178 32.455zm6.267-48.796l-39.456 18.837-3.017 22.469c-.464 3.405-2.553 6.355-5.802 7.944L68.08 155.15c-3.713 1.816-7.89-1.135-7.426-5.22l6.498-50.157-8.123-5.674c-.696-.454-.696-1.59.232-2.043l51.988-25.192c4.874-2.27 10.212 1.588 9.516 6.808l-.232 1.816-39.455 18.838-5.57 44.029 25.297-12.028 2.089-15.66-8.123-5.674c-.696-.681-.696-1.816.232-2.043l50.364-23.83c5.338-2.724 11.836 1.588 10.908 7.716z" fill={`url(#paint-${type})`}/>
      </g>
      <defs>
        <linearGradient id={`paint-${type}`} x1="71.399" y1="192.983" x2="133.428" y2="56.251" gradientUnits="userSpaceOnUse">
          <stop stopColor={colors.top}/>
          <stop offset="1" stopColor={colors.bottom}/>
        </linearGradient>
        <filter id={`filter-${type}`} x="0" y="0" width="216" height="232" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset/>
          {(!!shadow && colors.matrix) && (
            <>
              <feGaussianBlur xmlns="http://www.w3.org/2000/svg" stdDeviation="21">
                {!!pulse && (
                  <animate attributeName="stdDeviation" values="0;21;0" dur="2s" repeatCount="indefinite" keyTimes="0;0.5;1"/>
                )}
              </feGaussianBlur>
              <feColorMatrix values={colors.matrix} />
            </>
          )}
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset dy="4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"/>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"/>
        </filter>
      </defs>
    </SVG>
  )
}

export default PulsingLogo